// extracted by mini-css-extract-plugin
module.exports = {"Root":"StyledEditor_Root__1UDHV","Editor":"StyledEditor_Editor__goJBt","Highlighting":"StyledEditor_Highlighting__36PVM"};